import request from '@/service/http'

export function searchInit (classId) {
    return request({
      url: '/api/stuTrainLesson/searchInit',
      method: 'post',
      params: {classId},
    })
}

export function searchCoursesList (classId) {
  return request({
    url: '/api/stuTrainLesson/searchCoursesList',
    method: 'post',
    params: {classId},
  })
}

export function courseDetail (courseId) {
  return request({
    url: '/api/stuTrainLesson/courseDetail',
    method: 'post',
    params: {courseId},
  })
}

export function searchList (data) {
  return request({
    url: '/api/stuTestPaper/homeWorkPageList',
    method: 'post',
    data,
  })
}

export function theoryDetail (data) {
  return request({
    url: 'api/stuTestPaper/theoryDetail',
    method: 'post',
    data,
  })
}

export function theorySave (data) {
  return request({
    url: 'api/stuTestPaper/theorySave',
    method: 'post',
    data,
  })
}

export function practiceDetail (data) {
  return request({
    url: 'api/stuTestPaper/practiceDetail',
    method: 'post',
    data,
  })
}

export function practiceSave (data) {
  return request({
    url: 'api/stuTestPaper/practiceSave',
    method: 'post',
    data,
  })
}

